// extracted by mini-css-extract-plugin
export default {"tagsList":"MasksTagsList_tagsList__tPFNl"};